import { Vue, prop, Options, setup } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { InputWrapper, BaseTextInputProps, useInput } from '@/components/fields/input-wrapper';
import { maska } from 'maska';

class InputProps extends BaseTextInputProps {
	type = prop<string>({ default: 'text' })

	mask = prop<string | string[]>({ default: undefined }) // https://beholdr.github.io/maska/

	onRaw = prop<Function>({ default: () => () => undefined })
}

@Options({
	directives: { maska },
})
export class Input extends Vue.with(InputProps) {
	input = setup(() => useInput(this.$props));

	element: HTMLInputElement | null = null

	mounted() {
		this.element = this.$refs.element as HTMLInputElement;
	}

	@Watch('modelValue')
	triggerMask() {
		if (this.element && this.mask) {
			this.$nextTick(() => this.element?.dispatchEvent(new Event('input')));
		}
	}

	onMask(e: Event) {
		const { maskRawValue } = (e.target as HTMLInputElement).dataset;

		this.onRaw(maskRawValue);
	}

	render() {
		return (
			<InputWrapper
				icon={ this.icon }
				error={ this.error }
				label={ this.label }
				id={ this.input.id }
				valid={ this.input.showValid }
				prefix={ this.prefix }
				isTextOnRight={ this.isTextOnRight }>
				<input
					ref="element"
					id={ this.input.id }
					v-maska={ this.mask }
					onInput={ this.input.onInput }
					value={ this.input.input }
					placeholder={ this.placeholder }
					type={ this.type }
					disabled={ this.disabled }
					onBlur={ this.input.onBlur }
					onMaska={ this.onMask }
				/>
			</InputWrapper>
		);
	}
}
